export default "__VITE_ASSET__DNNVgHUO__"